<template>
  <div>
    <div class="row">
      <div class="col"></div>
      <div class="col-12 col-md-8 text-center">
        <span v-if="privacyInfoEnabled">
          <a
            href="#"
            aria-expanded="false"
            aria-controls="privacyInfo"
            v-on:click="showPrivacyInfo"
          >
            {{ T.adatvedelem[lang] }}
          </a>&nbsp;-&nbsp;
        </span>
        <a
          href="#"
          aria-expanded="false"
          aria-controls="bruttoNettoInfo"
          v-on:click="showBruttoNettoInfo"
        >{{ T.bruttoNettoInfo[lang] }}</a>
      </div>
      <div class="col"></div>
    </div>
    <div class="row mt-2">
      <div class="col"></div>
      <div class="col-12 col-md-8 text-center">
        <div
          id="privacyInfo"
          class="alert alert-info"
          :class="{'collapse.show' : privacyInfoShow, 'collapse': !privacyInfoShow}"
          role="alert"
        >{{ T.privacyInfo[lang] }}</div>
        <div
          id="bruttonettoinfo"
          class="alert alert-info"
          role="alert"
          v-bind:class="{'collapse.show' : bruttoNettoInfoShow, 'collapse': !bruttoNettoInfoShow}"
        >
          <p class="text-justify">
            <strong>{{ T.nettoBer[lang] }}:</strong>
            {{ T.nettoBerInfo[lang] }}
          </p>
          <p class="text-justify">
            <strong>{{ T.haviBruttoBer[lang] }}:</strong>
            {{ T.bruttoBerInfo[lang] }}
          </p>
          <p class="text-justify">
            <strong>{{ T.munkaltatoiAdok[lang] }}:</strong>
            {{ T.munkaltatoiAdokInfo[lang] }}
          </p>
        </div>
      </div>
      <div class="col"></div>
    </div>
  </div>
</template>

<script>
import { DREAMJOBS } from '../js/main';
import { T } from '../js/translations';

export default {
  props: {
    lang: String
  },
  data: function() {
    return {
      privacyInfoShow: false,
      privacyInfoEnabled: !DREAMJOBS,
      bruttoNettoInfoShow: false,
      T: T
    };
  },
  methods: {
    showPrivacyInfo: function(e) {
      this.bruttoNettoInfoShow = false;
      this.privacyInfoShow = !this.privacyInfoShow;
    },
    showBruttoNettoInfo: function(e) {
      this.privacyInfoShow = false;
      this.bruttoNettoInfoShow = !this.bruttoNettoInfoShow;
    },
    collapseAll: function() {}
  }
};
</script>



// WEBPACK FOOTER //
// Info.vue?34f4ad4b